module.exports = __webpack_public_path__ + "media/packs/images/flags/SN-c38c0245094233daff0ddab28391f7ad.svg";